import { render, staticRenderFns } from "./PresupuestoLineaCom.vue?vue&type=template&id=511c2f6f"
import script from "./PresupuestoLineaCom.vue?vue&type=script&lang=js"
export * from "./PresupuestoLineaCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports